module.exports = __webpack_public_path__ + "img/wordmark.ca16493d.svg";